<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaMarc" class="form-label">IdVacunaMarc</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaMarc" name="idVacunaMarc" v-model="datoVacunaMarc.idVacunaMarc" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idVacuna" class="form-label"> Vacuna</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idVacuna" name="idVacuna" v-model="datoVacunaMarc.idVacuna">
                      <option v-for="vacuna in vacunas" :value="vacuna.idVacuna" :key="vacuna.idVacuna">
                        {{ vacuna.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoVacunaMarc.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoVacunaMarc.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarVacunaMarc" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditVacunaMarc" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdVacunaProd</th>
          <th scope="col">IdVacunaMarc</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">Estado</th>
          <th scope="col">VacunaMarcNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vacunaprod in datosPaginados" :key="vacunaprod.idVacunaProd">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(vacunaprod.idVacunaProd)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(vacunaprod.idVacunaProd)" title="Editar">edit_square</i></td>
          <td>{{vacunaprod.idVacunaProd}}</td>
          <td>{{vacunaprod.idVacunaMarc}}</td>
          <td>{{getFormattedDate(vacunaprod.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(vacunaprod.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{vacunaprod.estado}}</td>
          <td>{{vacunaprod.vacunaMarcNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteVacunaMarc(vacunaprod.idVacunaProd)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaProd" class="form-label">IdVacunaProd</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaProd" name="idVacunaProd" v-model="datoVacunaProd.idVacunaProd" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idVacunaMarc" class="form-label">IdVacunaMarc</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idVacunaMarc" name="idVacunaMarc" v-model="datoVacunaProd.idVacunaMarc" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoVacunaProd.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoVacunaProd.fechaAct" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarVacunaProd" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditVacunaProd" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      vacunamarcs : [],
      datoVacunaMarc : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idVacunaMarc: '',
      vacunas : [],
// Variables master
// Variables details
      vacunaprods : [],
      datoVacunaProd : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      vacunaMarcs : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idVacunaMarc = this.$route.params.p_idvacunamarc
    this.abrirEditar(this.p_idVacunaMarc)
    this.getDataPagina(this.paginaActual)
    this.fetchVacunas()
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      const requiredFieldsText = [
        'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      return validarForm(this.datoVacunaMarc, requiredFields, requiredFieldsText);
    },
    async guardarVacunaMarc(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunamarcs', this.datoVacunaMarc)
          swal("Correcto!", "VacunaMarc creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditVacunaMarc(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunamarcs', this.datoVacunaMarc)
          swal("Correcto!", "VacunaMarc creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoVacunaMarc={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idVacunaMarc){
      this.modalWindow = true
      if(idVacunaMarc != null){    
           api.get('/vwvacunamarcs/'+idVacunaMarc).then(resp=>{
          this.datoVacunaMarc = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarVacunaMarc(){
      this.$router.push('/VacunaMarc')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.vacunaprods.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwvacunaprods/nombre/'+this.nombreBusqueda).then(response=>{
          this.vacunaprods=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.vacunaprods.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwvacunaprods').then(response=>{
      this.vacunaprods=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.vacunaprods.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      const requiredFieldsText = [
        'idVacuna'
        ,'nombre'
        ,'descripcion'
      ];
      return validarForm(this.datoVacunaMarc, requiredFields, requiredFieldsText);
    },
    async guardarVacunaProd(){
      if(this.validarForm() === 1){
        try {
          this.datoVacunaProd.idVacunaMarc = this.datoVacunaMarc.idVacunaMarc;
          await api.post('/vacunaprods', this.datoVacunaProd)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "VacunaProd creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditVacunaProd(){
      if(this.validarForm() === 1){
        try {
          await api.post('/vacunaprods', this.datoVacunaProd)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "VacunaProd creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoVacunaProd={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idVacunaProd){
      this.modalWindow = true
      if(idVacunaProd != null){    
           api.get('/vwvacunaprods/'+idVacunaProd).then(resp=>{
          this.datoVacunaProd = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idVacunaProd){
      this.modalWindow = true
      if(idVacunaProd != null){
        this.$router.push('/vacunaprodmd/'+idVacunaProd)
      }
    },
    async deleteVacunaProd (idVacunaProd) {
      try{
        await api.delete('/vacunaprods/'+idVacunaProd)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchVacunas() {
      fetch('http://localhost:8080/api/v1/vacunas')
        .then(response => response.json())
        .then(data => {
          this.vacunas = data;
        })
        .catch(error => {
          console.error('Error fetching vacunas:', error);
        });
    },
    fetchVacunaMarcs() {
      fetch('http://localhost:8080/api/v1/vacunamarcs')
        .then(response => response.json())
        .then(data => {
          this.vacunaMarcs = data;
        })
        .catch(error => {
          console.error('Error fetching vacunaMarcs:', error);
        });
    },
  },
}
</script>
